import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormGroupDirective } from '@angular/forms';
import { ResidentService } from '../resident.service';
import { Observable } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { vovSharedService } from 'src/app/shared/services/vov-shared.service';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';




@Component({
  selector: 'app-sign-up',
  templateUrl: './waiver-register.component.html',
  styleUrls: ['./waiver-register.component.scss']
})
export class WaiverRegisterComponent implements OnInit {
  registerForm: FormGroup;
  public isAlreadyregistered: boolean = false;
  public registerMessage: string = '';
  private waiver: any;
  public showSpinner: boolean = false;
  public states = [];
  public confirm: MatDialogRef<any> = null;
  filteredOptions: Observable<string[]>;
  public phone_num;
  public zip_code: any;
  @ViewChild('confirmRef') confirmRef: TemplateRef<any>;



  constructor(
    private activeRouter: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private residentService: ResidentService,
    public snackBar: MatSnackBar,
    private vovSharedService: vovSharedService,
    public dialog: MatDialog,
    //private adminService: AdminService
  ) { }

  ngOnInit(): void {
    this.registerForm = this.formBuilder.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      phone_no: ['', Validators.required],
      // streetNumber: ['', Validators.required],
      // street: ['', Validators.required],
      email: ['', Validators.required],
      city: ['', [Validators.required]],
      stateId: ['', Validators.required],
      address: ['', Validators.required],
      zipcode: ['', Validators.required],
    });


    this.vovSharedService.fetchAllStates().subscribe((res) => {
      this.states = res.statesList;

      const toSelect = this.states.sort((a, b) => a.state.localeCompare(b.state)).filter(s => s.state == 'IL')
      if (toSelect) {
        this.registerForm.get("stateId").patchValue(toSelect[0].id);
      }
      let temStates = res.statesList;
      let result = [];
      result.push(temStates.find(f => f.state == 'IL'));
      result.push(temStates.find(f => f.state == 'WI'));
      temStates = temStates.filter(f => f.state != 'IL' && f.state != 'WI');
      temStates.forEach(element => {
        result.push(element)
      });
      this.states = result;
    });
  }

  onSubmit(formDirective: FormGroupDirective) {
    if (this.registerForm.invalid) {
      return;
    }
    console.log(this.registerForm.value, 'valueee');
    this.residentService.saveWaiverDetail(this.registerForm.value).subscribe((res) => {
      if (res) {
        // const currentWaiverId = res.result.id;
        // localStorage.setItem('currentWaiverId', currentWaiverId);
        if (res && res.result && res.result.waiver_vehicle_id) {
          const waiver_vehicle_id = res.result.waiver_vehicle_id;
          localStorage.setItem('waiver_vehicle_id', waiver_vehicle_id);
        }

        this.registerMessage = '';
        this.confirm = this.dialog.open(this.confirmRef, {
          width: '350px',
          data: 'data',
        })

      }
    })
    formDirective.resetForm();
    this.registerForm.reset();
    //this.registerForm.setErrors(null);
  }

  onClose() {
    this.confirm.close()
  }


}
